import { WebProduct } from '@matematykagryzie/models';

import { AppType } from '../app-type';
import { Period } from '../period';
import { periodToAmount } from './period-to-amount';
import { ProductPlatform } from './product-platform';
import { ProductType } from './product-type';
import { WebProductId } from './web-product-id';

const webCommonProduct: Pick<WebProduct, 'platform' | 'type' | 'currency'> = {
  platform: ProductPlatform.Web,
  type: ProductType.OneTimePurchase,
  currency: 'PLN',
};

const webMaturaBaseProduct: Pick<
  WebProduct,
  | 'platform'
  | 'type'
  | 'currency'
  | 'appType'
  | 'shortName'
  | 'valueProposition'
  | 'description'
  | 'apps'
> = {
  ...webCommonProduct,
  appType: AppType.Matura,
  shortName: 'Kurs maturalny z matematyki',
  valueProposition: 'Zdana matura z matematyki',
  description:
    'Naucz się powtarzalnych zadań na maturze i zdobądź wymarzone 30%',
  /** @deprecated */
  apps: [AppType.Matura],
};

const webExamBaseProduct: Pick<
  WebProduct,
  | 'platform'
  | 'type'
  | 'currency'
  | 'appType'
  | 'shortName'
  | 'valueProposition'
  | 'description'
  | 'apps'
> = {
  ...webCommonProduct,
  appType: AppType.Exam,
  shortName: 'Kurs dla ósmoklasistów',
  valueProposition: '100% na Egzaminie 8kl',
  description: 'Nadrób zaległości i dostań się do wymarzonej szkoły',
  /** @deprecated */
  apps: [AppType.Exam],
};

export const maturaM1: WebProduct = {
  ...webMaturaBaseProduct,
  productId: WebProductId.MaturaM1,
  period: Period.M1,
  amount: periodToAmount.get(Period.M1),
  regularAmount: null,
  name: 'Miesięczny dostęp do kursu maturalnego z matematyki.',
  externalProductId: 11461259,
};

export const maturaM3: WebProduct = {
  ...webMaturaBaseProduct,
  productId: WebProductId.MaturaM3,
  period: Period.M3,
  amount: periodToAmount.get(Period.M3),
  regularAmount: 3 * 3900,
  name: 'Trzy miesięczny dostęp do kursu maturalnego z matematyki.',
  externalProductId: 11461260,
};

export const maturaM6: WebProduct = {
  ...webMaturaBaseProduct,
  productId: WebProductId.MaturaM6,
  period: Period.M6,
  amount: periodToAmount.get(Period.M6),
  regularAmount: 6 * 3900,
  name: 'Sześcio miesięczny dostęp do kursu maturalnego z matematyki.',
  externalProductId: 11608262,
};

export const maturaM12: WebProduct = {
  ...webMaturaBaseProduct,
  productId: WebProductId.MaturaM12,
  period: Period.M12,
  amount: periodToAmount.get(Period.M12),
  regularAmount: 12 * 3900,
  name: 'Roczny dostęp do kursu maturalnego z matematyki.',
  externalProductId: 11461261,
};

export const examM1: WebProduct = {
  ...webExamBaseProduct,
  productId: WebProductId.ExamM1,
  period: Period.M1,
  amount: periodToAmount.get(Period.M1),
  regularAmount: null,
  name: 'Miesięczny dostęp do kursu przygotowującego do egzaminu ósmoklasisty.',
  externalProductId: 11461262,
};

export const examM3: WebProduct = {
  ...webExamBaseProduct,
  productId: WebProductId.ExamM3,
  period: Period.M3,
  amount: periodToAmount.get(Period.M3),
  regularAmount: 3 * 3900,
  name: 'Trzy miesięczny dostęp do kursu przygotowującego do egzaminu ósmoklasisty.',
  externalProductId: 11461264,
};

export const examM6: WebProduct = {
  ...webExamBaseProduct,
  productId: WebProductId.ExamM6,
  period: Period.M6,
  amount: periodToAmount.get(Period.M6),
  regularAmount: 6 * 3900,
  name: 'Sześcio miesięczny dostęp do kursu przygotowującego do egzaminu ósmoklasisty.',
  externalProductId: 11608263,
};

export const examM12: WebProduct = {
  ...webExamBaseProduct,
  productId: WebProductId.ExamM12,
  period: Period.M12,
  amount: periodToAmount.get(Period.M12),
  regularAmount: 12 * 3900,
  name: 'Roczny dostęp do kursu przygotowującego do egzaminu ósmoklasisty.',
  externalProductId: 11461265,
};

export const webProducts = [
  maturaM1,
  maturaM3,
  maturaM6,
  maturaM12,
  examM1,
  examM3,
  examM6,
  examM12,
];
